$(() => {
    // табы
    $('.js-tabs-btn').on('click', function (e) {
        e.preventDefault();
        const btnId = $(this).data('id');
        $('.tabs-btn').removeClass('tabs-btn--active');
        $(this).addClass('tabs-btn--active');
        $('.tabs-body').removeClass('tabs-body--active');
        $('#' + btnId).addClass('tabs-body--active');
    });
});



// WEBPACK FOOTER //
// ./markup/components/product/body/body.js